import { ACCESS_TOKEN_NAME, JSON_CONTENT_TYPE } from '../_constant/constants';
import { IApiParams } from '../_interface/IApiParams';
import { getApi } from './getApi';

export const apiGetRegNum = async (type: number, contractId: number) => {
  const params: IApiParams = {
    url: `/getRegNum.php?num=${type}&contractId=${contractId}`,
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': localStorage.getItem(ACCESS_TOKEN_NAME),
    },
  };
  return getApi(params, 'GET');
};
